var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00065,
    cy: 7.99992,
    r: 6,
    stroke: "#EB4D3D",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3333V7.33325",
    stroke: "#EB4D3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00065,
    cy: 4.66667,
    r: 0.666667,
    fill: "#EB4D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviationLogo);
export default __webpack_public_path__ + "static/media/deviation_logo.df2ebeddf5ce6d9db215e4393907434e.svg";
export { ForwardRef as ReactComponent };